import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

import data from './modules/data';
import auth from './modules/auth';
import alert from './modules/alert';
import brands from './modules/brands';
import orders from './modules/orders';
import settings from './modules/settings';
import resales from './modules/resales';
import notifications from './modules/notifications';
import addresses from './modules/addresses';
import bonuses from './modules/bonuses';
import reports from './modules/reports';
import users from './modules/users';
import finances from './modules/finances';
import photoReasons from './modules/photoReasons';
import photoReports from './modules/photoReports';
import logging from './modules/logging';
import forms from './modules/forms';
import formAnswers from '@/store/modules/formAnswers';
import technicalSupport from './modules/technicalSupport';
import paymentTypes from './modules/payment-types';
import establishments from './modules/establishments';
import establishmentsCategories from './modules/establishmentsCategories';
import establishmentsTypes from './modules/establishmentsTypes';
import deliverySections from './modules/deliverySections';
import deliveryProducts from './modules/deliveryProducts';
import driverNews from './modules/driver-news';
import driverNewsView from './modules/driver-news-view';
import productImport from "@/store/modules/productImport";

Vue.use(Vuex);

const store = new Vuex.Store({
    getters,
    modules: {
        data,
        auth,
        alert,
        brands,
        orders,
        settings,
        resales,
        notifications,
        addresses,
        bonuses,
        reports,
        users,
        finances,
        logging,
        photoReasons,
        photoReports,
        forms,
        formAnswers,
        technicalSupport,
        paymentTypes,
        establishments,
        establishmentsCategories,
        establishmentsTypes,
        deliverySections,
        deliveryProducts,
        driverNews,
        productImport,
        driverNewsView
    }
});

export default store;

const initialStateCopy = JSON.parse(JSON.stringify(store.state));

export function resetState() {
    store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)));
}
